import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import './styles/InputForm.css';

import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';

const InputForm = ({
    codes,
    setCodes,
    origin,
    setOrigin,
    transportModes,
    setTransportModes,
    onSearch,
    onReset
}) => {

    const config = require('../config.js');
    const BASE_URL = config.BASE_URL;

    const toggleMode = (mode) => {
        setTransportModes((prev) => ({
            ...prev,
            [mode]: !prev[mode],
        }));
    };

    const validateOrigin = (value) => {
        setOrigin((prev) => ({
            ...prev,
            valid: value.trim() !== "",
            checked: false,
        }));
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setOrigin((prev) => ({
            ...prev,
            address: value,
            reformatted: false
        }));
        validateOrigin(value);
        e.target.setCustomValidity("");
    };

    const captchaSecretKey ="6LdpdNYqAAAAALQyKiO5ohEKsVqa_te9GIllZO5a";
    const [captchaToken, setCaptchaToken] = useState(null);
    const recaptchaRef = useRef(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaToken) {
            alert("Por favor, verifica el captcha");
            return;
        }

        // Send to backend for verification
        const response = await fetch(`${BASE_URL}verify-captcha`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token: captchaToken }),
          });
          
    
        const data = await response.json();
        if (data.success) {
            // If correct captcha, reset token and start search
            setCaptchaToken(null); // Reset the token
            recaptchaRef.current?.reset(); // Reset reCAPTCHA
            
            await onSearch();
            
            //alert("Captcha verificado correctamente!"); // Uncomment when testing, if needed

        } else {
            alert("Fallo en la verificación del captcha");
            
        }
    };

    return (
        <div className="row">      
            <form className="form-container" autoComplete="on">
                <div className="row m-t-20">
                    <div className="col-12">
                        <label htmlFor="comments">Introduce los códigos separados por espacios, comas o intros:</label>
                        <InputTextarea 
                            value={codes}
                            name="comments" autoComplete="on"
                            onChange={(e) => setCodes(e.target.value)}
                            placeholder="Pon los códigos aquí. Ejemplo: 28077658, 28022335, 28044896, 28002853"
                            rows={4}
                            className="input-style"/>
                    </div>
                </div>

                <div className="row m-t-20">
                    <div className="col-12">
                        <label htmlFor="address">Introduce tu dirección de origen:</label>
                        <InputText 
                            value={origin.address}
                            onChange={handleChange}
                            placeholder="Ejemplo: Calle Mayor, 1, 28013, Madrid"
                            name="address" autoComplete="address"
                            className={`input-style ${(origin.checked && !origin.valid) ? "input-invalid" : ""}`} // Add a class if invalid                  
                        />
                        {origin.checked && !origin.valid && (
                            <small className="error-message">Dirección de origen no encontrada. Por favor, introduce una distinta</small>
                        )}
                    </div>
                </div>

                <div className="row m-t-20">
                    <label htmlFor="transportModes">Selecciona el modo de transporte:</label>
                    <div className="col-3">
                        <input
                            type="checkbox"
                            checked={transportModes.walking}
                            onChange={() => toggleMode('walking')}
                        /> Andando
                    </div>
                    <div className="col-3">
                        <input
                            type="checkbox"
                            checked={transportModes.driving}
                            onChange={() => toggleMode('driving')}
                        /> Coche
                    </div>
                    <div className="col-2">
                        <input
                            type="checkbox"
                            checked={transportModes.biking}
                            onChange={() => toggleMode('biking')}
                        /> Bici
                    </div>
                    <div className="col-4">
                        <input
                            type="checkbox"
                            checked={transportModes.transit}
                            onChange={() => toggleMode('transit')}
                        /> Transporte público
                    </div>
                </div>

                <div className="row m-t-20">
                    <div className="col-md-6">
                        <button
                            type="submit"
                            onClick={handleSubmit}
                            className="button format-button"
                            disabled={!codes.trim() || (origin.checked && !origin.valid) || !captchaToken} // Disable if fields are empty
                        >
                            Iniciar búsqueda
                        </button>
                    </div>
                    <div className="col-md-6">
                        <button onClick={onReset} className="button clear-button">Limpiar campos</button>
                    </div>
                </div>

                <div className="row m-t-20">
                    <div className="col-md-6">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={captchaSecretKey}
                            onChange={setCaptchaToken}
                        />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default InputForm;